<template>
  <h2>Hi</h2>
</template>

<script>
// import drugs from "../assets/Drugs.json"

export default {

}
</script>

<style>

</style>
